// plugins/aoi/aoiToolFactory.ts
import type { Dispatch, UnknownAction } from "redux";
import { createCesiumDrawingAOI } from "./helpers/cesium";
import { createLeafletDrawingAOI } from "./helpers/leaflet";
import { createMapLibreDrawingAOI } from "./helpers/maplibre";
import { createOLDrawingAOI } from "./helpers/openlayers";
import type { DrawAOIFeature, DrawingAOIMode } from "./types";

export function createDrawingTool(
  mapIntance: any,
  mapType: string,
  mode: DrawingAOIMode,
  editingFeatureId: string | null,
  features: DrawAOIFeature[],
  dispatch: Dispatch<UnknownAction> | any,
  layers?: any,
  activeFeatureId: string | null = null,
  allowMoveActive = true,

)
{
  if (mapType === "openlayers")
  {
    return createOLDrawingAOI(mapIntance, mode, editingFeatureId, features, dispatch);
  }

  if (mapType === "leaflet")
  {
    return createLeafletDrawingAOI(mapIntance, mode);
  }

  if (mapType === "maplibre")
  {
    return createMapLibreDrawingAOI(mapIntance, mode, editingFeatureId, features, dispatch, false, layers, activeFeatureId, allowMoveActive);
  }

  if (mapType === "cesium")
  {
    return createCesiumDrawingAOI(mapIntance, mode);
  }

  throw new Error("Unsupported engine");
}
